import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setActiveId, setCurrentPage } from "../../features/filter/filterSlice";

const Pagination = ({ filteredTransactions, currentTransactions }) => {
    const { transactions } = useSelector((state) => state.transaction);
    const { activeId, transactionPerPage } = useSelector(
        (state) => state.filter
    );
    const dispatch = useDispatch();

    useEffect(() => {
        if (currentTransactions?.length === 0) {
            dispatch(setCurrentPage(1));
        }
    }, [currentTransactions, dispatch]);

    let pageNumbers = [];
    for (
        let i = 1;
        i <=
        Math.ceil(
            filteredTransactions?.length > 0
                ? filteredTransactions?.length / transactionPerPage
                : transactions?.length / transactionPerPage
        );
        i++
    ) {
        pageNumbers.push(i);
    }

    const handlePageChange = (pageNum) => {
        dispatch(setCurrentPage(pageNum));
        dispatch(setActiveId(pageNum));
    };

    return (
        <section className="pagination">
            <ul className="pagination_items">
                {pageNumbers.length !== 1 &&
                    pageNumbers?.map((pageNum) => (
                        <li
                            key={pageNum}
                            onClick={() => handlePageChange(pageNum)}
                            className={`pagination_item ${
                                activeId === pageNum && "active"
                            }`}
                        >
                            {pageNum}
                        </li>
                    ))}
            </ul>
        </section>
    );
};

export default Pagination;
